import { Outlet } from 'react-router';
import Sidebar from '~/components/sidebar/sidebar';

export default function SessionLayout() {
  return (
    <div className="flex flex-row h-screen w-full">
      <div className="h-full">
        <Sidebar />
      </div>
      <div className="h-full grow overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
